import React from 'react';
import { EndTest } from './EndTest';
import { OfflineModal } from './OfflineModal';
import ConnectionIndicator from './ConnectionIndicator';
import { useContextEffect, useNetworkStatus, useStableCallback } from '../../../hooks';

const AssignmentAction = (props) => {
  const {
    onEndTest,
    pauseTimer,
    startTimer,
    hasTimer,
    countdown,
    isSubmitting,
    isMediaBusy = false,
    assignment,
    studentResponse
  } = props;
  const { isOnline, isBrowserOnline, previousStatus } = useNetworkStatus();
  const [isOfflineModalOpen, setIsOfflineModalOpen] = React.useState(false);

  const isTimerExpired = useStableCallback(() => {
    return countdown === '00:00:00' || countdown === '00:00:01' || countdown === '00:00:02';
  });

  // Pause + Connection Lost modal only when connectivity is lost via a failed write/timer sync,
  // not merely when the browser reports offline.
  useContextEffect({
    deps: [previousStatus, isOnline],
    ctx: { isSubmitting, isTimerExpired, hasTimer, pauseTimer, startTimer, isMediaBusy },
    cb: (ctx) => {
      if (previousStatus && !isOnline) {
        if (ctx.isSubmitting || ctx.isTimerExpired()) {
          console.log('Test is being submitted or timer expired, not pausing timer');
        } else if (ctx.hasTimer) {
          ctx.pauseTimer?.();
        }
        setIsOfflineModalOpen(true);
      } else if (!previousStatus && isOnline) {
        if (ctx.isSubmitting || ctx.isTimerExpired() || ctx.isMediaBusy) {
          console.log('Test is being submitted, timer expired, or media busy — not resuming timer');
        } else if (ctx.hasTimer) {
          ctx.startTimer?.();
        }
        setIsOfflineModalOpen(false);
      }
    }
  });

  return (
    <>
      <div
        className={
          isOfflineModalOpen
            ? 'pointer-events-none flex items-center gap-2 sm:gap-3 opacity-60'
            : 'flex items-center gap-2 sm:gap-3'
        }
        aria-hidden={isOfflineModalOpen || undefined}
      >
        <ConnectionIndicator isOnline={isBrowserOnline} />
        <EndTest
          onEndTest={onEndTest}
          isSubmittingResponse={isSubmitting || isOfflineModalOpen}
          assignment={assignment}
          studentResponse={studentResponse}
          highlighted
        />
      </div>

      <OfflineModal isOpen={isOfflineModalOpen} />
    </>
  );
};

export default AssignmentAction;
